import React from 'react';
import { AboutConfig } from '../types/profile';
import { useLocalization } from '../engine/localization/context';
import { Building2, Sparkles } from 'lucide-react';

interface AboutSectionProps {
  about?: AboutConfig;
}

export const AboutSection: React.FC<AboutSectionProps> = ({ about }) => {
  const { resolve } = useLocalization();

  if (!about || !about.paragraphs || about.paragraphs.length === 0) {
    return null;
  }

  const title = resolve(about.title);

  return (
    <section aria-label="About Us" className="my-5 sm:my-6">
      <div className="rounded-2xl p-3.5 sm:p-5 bg-slate-900/60 backdrop-blur-md border border-slate-800/80 shadow-md">
        <div className="flex items-center gap-2 mb-3 px-1 border-b border-white/5 pb-2.5">
          <div className="w-8 h-8 rounded-lg bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center text-emerald-400">
            <Building2 className="w-4 h-4" />
          </div>
          <h2 className="text-base font-bold text-white flex items-center gap-2">
            <span>{title}</span>
            <Sparkles className="w-3.5 h-3.5 text-amber-400" />
          </h2>
        </div>

        <div className="space-y-2.5 text-xs sm:text-sm text-slate-300/90 leading-relaxed text-start">
          {about.paragraphs.map((p, idx) => (
            <p key={idx} className="leading-relaxed">
              {resolve(p)}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};
